import { LoadingDataField } from "components/commons";
import locale from "localization/en";
import { dateTimeFormat, formatAmount } from "utils";
import { isNumber } from "lodash";
import { prettifyKeyPaymentMethod } from "utils/pretty.utils";

const ViewKeyAccount = ({ collection }) => {
  const prettifyShiftDate = (startDate, endDate) => {
    return `${dateTimeFormat(startDate) ?? ""} - ${dateTimeFormat(endDate) ?? ""}`;
  };

  return (
    <>
      <LoadingDataField
        data={collection}
        label={locale.collectionId}
        value={collection?.keyAccountCollectionId}
      />
      <LoadingDataField
        data={collection}
        label={locale.collectionDateAndTime}
        value={collection?.dateTime ? dateTimeFormat(collection?.dateTime) : "--"}
      />
      <LoadingDataField
        data={collection}
        label={locale.shiftDateAndTime}
        value={
          collection?.shift
            ? prettifyShiftDate(collection?.shift.startShift, collection?.shift.endShift)
            : "--"
        }
      />
      <LoadingDataField
        data={collection}
        label={locale.amount}
        value={isNumber(collection?.amount) ? formatAmount(collection?.amount || 0) : "--"}
      />
      <LoadingDataField
        data={collection}
        label={locale.remarks}
        value={collection?.remarks ? collection?.remarks : "--"}
      />
      <LoadingDataField
        data={collection}
        label={locale.siNumSoa}
        value={collection?.siNumber ? collection?.siNumber : "--"}
      />
      <LoadingDataField
        data={collection}
        label={locale.keyAccountCode}
        value={collection?.keyAccountCode ? collection?.keyAccountCode : "--"}
      />
      <LoadingDataField
        data={collection}
        label={locale.keyAccountName}
        value={collection?.keyAccountName ? collection?.keyAccountName : "--"}
      />
      <LoadingDataField
        data={collection}
        label={locale.paymentMethod}
        value={
          collection?.paymentMethod ? prettifyKeyPaymentMethod(collection?.paymentMethod) : "--"
        }
      />
      <LoadingDataField
        data={collection}
        label={locale.referenceNumber}
        value={collection?.referenceNumber ? collection?.referenceNumber : "--"}
      />
    </>
  );
};

export default ViewKeyAccount;
